import React from 'react'
import { useDispatch } from 'react-redux'
import {
  Box,
  Button
} from '@mui/material'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { addToCart } from '@/modules/cart/cartSlice'
import { CartItem } from '@/modules/cart/types/cart'
import { createLogger } from '@/common/logger'

const logger = createLogger({prefix: 'AddToCart'})

type AddToCartProps = {
} & CartItem

const AddToCart = (props: AddToCartProps) => {
  const dispatch = useDispatch()
  const { product, option, quantity, shippingType } = props
  const disabled = quantity == 0 || !(shippingType === 'SHIP_ITEM' || shippingType === 'EVENT_PICKUP') || option.remaining === 0
  const title = quantity == 0 ? 'Must select a quantity' : !(shippingType === 'SHIP_ITEM' || shippingType === 'EVENT_PICKUP') ? 'Must select a shipping type' : undefined
  const onAdd = () => {
    if (product && option?.id && quantity > 0) {
      dispatch(addToCart({ product, option, quantity, shippingType }))
    } else {
      logger.warn('Can not add to cart: ', { product, option, quantity, shippingType })
    }
  }

  return (
    <Box title={title}>
      <Button
        disabled={disabled}
        variant={'contained'}
        onClick={onAdd}
        startIcon={<ShoppingCartIcon/>}>
  
        Add to Cart
  
      </Button>
    </Box>
  )
}

export default AddToCart